@use "/src/styles/functions";

.dropdownInputBox {
  cursor: pointer;
  input {
    cursor: pointer;
  }
}
.stick {
  position: sticky;
  top: 0;
}
.flex0 {
  flex: 0 0 auto;
}
